import { cn } from "@omni/utils/styles";

export const FinishSkeleton = () => {
    return (
        <>
            <div className={cn("tw:h-7.5 tw:w-20 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-25 tw:rounded-sm tw:bg-grey")} />
        </>
    );
};
